import { ISingleIdParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IIsWorkbookServerRefreshableResult extends IResult {
  refreshable: boolean;
}

export class IIsWorkbookServerRefreshableRequest extends Request<ISingleIdParams, IIsWorkbookServerRefreshableResult> {
  constructor(params: ISingleIdParams) {
    super('isWorkbookServerRefreshable', params);
  }
}
